import React from 'react';
import PropTypes from 'prop-types';

const optionProps = ['width', 'height', 'top', 'left', 'menubar', 'resizable', 'scrollbar', 'location', 'modal', 'status'];

class PopupLink extends React.Component {
    render(){
        return (
            <a href={ this.props.href } onClick={ this.onLinkClick.bind(this) }>{ this.props.children }</a>
        );
    }

    onLinkClick(event) {
        event.preventDefault();
        window.open(this.props.href, this.props.name, this.getOptions());
    }

    getOptions() {
        return optionProps
            .filter(propName => typeof this.props[propName] !== 'undefined' && this.props[propName] !== null) //Filter out null or undefined properties
            .map(propName => `${propName}=${Number(this.props[propName])}`) /*  Create key value pair for each property.
                                                                                Since our properties are either numbers or bool and we want bools represented as 0,1
                                                                                or no,yes the easiest way to achieve this is to convert them to numbers.*/
            .join(',');
    }
}

PopupLink.propTypes = {
    href: PropTypes.string.isRequired,
    name: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    top: PropTypes.number,
    left: PropTypes.number,
    menubar: PropTypes.bool,
    resizable: PropTypes.bool,
    scrollbar: PropTypes.bool,
    location: PropTypes.bool,
    modal: PropTypes.bool,
    status: PropTypes.bool
};

PopupLink.defaultProps = {
    name: '_blank'
}

export default PopupLink;
